import { createContext, useCallback, useContext, useEffect } from "react";

import useScreenDimensions from "../hooks/useScreenDimensions";
import { isMobile } from "react-device-detect";
import { ShepherdTourContext } from "../lib/shepherd";

export interface Cords {
  x: number;
  y: number;
}

export const ContextMenuContext = createContext<{
  setOpen: (cords: Cords, options: JSX.Element[]) => void;
  closeMenu: () => void;
  isOpen: boolean;
  options: JSX.Element[];
  cords: Cords;
}>({
  setOpen: (cords: Cords, options: JSX.Element[]) => undefined,
  closeMenu: () => undefined,
  isOpen: false,
  options: [],
  cords: { x: 0, y: 0 },
});

export const ContextMenu = () => {
  const { isOpen, options, closeMenu, cords } = useContext(ContextMenuContext);
  const { width, height } = useScreenDimensions();

  const shepherd = useContext(ShepherdTourContext);

  useEffect(() => {
    if(isOpen && shepherd.isActive() && shepherd.currentStep?.id.includes('Three Dots')) {
      if (!isMobile) {
        shepherd.next();
      } else {
        setTimeout(shepherd.next, 250)
      }
    } else if (!isOpen && shepherd.currentStep?.id === 'Click to Activate') {
      shepherd.next();
    }
  }, [isOpen])

  const shepherdSafeClose = useCallback(() => {
    if (shepherd.isActive() && shepherd.currentStep?.id === 'Context Menu') {
      return
    } else {
      closeMenu();
    }
  }, [closeMenu, shepherd]);


  if (!isOpen) {
    return null;
  }

  
  return (
    <div
      style={{
        position: "fixed",
        backgroundColor: "rgba(0,0,0,.3)",
        width,
        height,
        zIndex: 100,
      }}
      onClick={shepherdSafeClose}
    >
      <div
        style={{
          position: "absolute",
          backgroundColor: "#FFFFFF",
          width: isMobile ? width * .85 : "16rem",
          zIndex: 101,
          opacity: 1,
          top: cords.y,
          left: cords.x,
          borderRadius: 16,
          padding: 10
        }}
        className="contextMenu"
      >
        {options}
      </div>
    </div>
  );
};
